import React from 'react'
import { TRANS_TYPE } from '../../constants/TransType'
import { AccessTokenInput, AccountSelector, AppIdInput } from './components'

const { SFTP, FTP, VM5, TTD, META, GOOGLE_ADS } = TRANS_TYPE
export const transForm = {
  def: [],
  [SFTP]: [
    { key: 'account', type: 'input' },
    { key: 'password', type: 'inputPassword' },
    { key: 'port', type: 'inputNumber' },
    { key: 'path', type: 'input', defaultValue: '/' },
    { key: 'host', type: 'input' }
  ],
  [FTP]: [
    { key: 'account', type: 'input' },
    { key: 'password', type: 'inputPassword' },
    { key: 'port', type: 'inputNumber' },
    { key: 'path', type: 'input', defaultValue: '/' },
    { key: 'host', type: 'input' }
  ],
  [VM5]: [{ key: 'companyId', type: 'input' }],
  [TTD]: [
    { key: 'advertiserId', type: 'input' },
    { key: 'secretKey', type: 'inputPassword' }
  ],
  [META]: [
    { key: 'accessToken', type: 'input', noForm: true, customComponent: props => <AccessTokenInput {...props} /> },
    { key: 'accountId', type: 'select', noForm: true, dependency: 'accessToken', customComponent: props => <AccountSelector {...props} /> },
    { key: 'appId', type: 'input', noForm: true, customComponent: props => <AppIdInput {...props} /> },
    { key: 'appSecret', type: 'inputPassword' }
  ],
  [GOOGLE_ADS]: [
    { key: 'consumerId', type: 'input' },
    { key: 'managerId', type: 'input', required: false },
    { key: 'googleAdsDataType', type: 'select', options: ['email', 'phone', 'user id']?.map(i => ({ value: i, label: i })) }
  ]
}
